var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"ms-Icon",class:['ms-Icon', _vm.className],attrs:{"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }